
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#fff","d":"M0 0h32v32H0z"}}),_c('path',{attrs:{"d":"M16.012 5a6.539 6.539 0 00-2.439.464 6.322 6.322 0 00-2.061 1.333 5.735 5.735 0 00-1.307 1.914 5.538 5.538 0 00-.426 2.251c.09 3.709 5.34 12.938 5.565 13.326.067.11.163.201.278.264a.776.776 0 00.379.095.776.776 0 00.378-.095.736.736 0 00.278-.264c.229-.392 5.565-9.624 5.565-13.344a5.847 5.847 0 00-1.827-4.198A6.369 6.369 0 0016.012 5zm0 8.424a2.95 2.95 0 01-1.59-.46 2.772 2.772 0 01-1.056-1.23 2.637 2.637 0 01-.165-1.585c.11-.532.383-1.021.783-1.405.4-.384.91-.645 1.465-.751a2.977 2.977 0 011.653.155c.523.208.97.559 1.285 1.01.314.451.482.981.482 1.524 0 .726-.3 1.423-.836 1.937a2.926 2.926 0 01-2.021.805zm1.357-2.742c0 .257-.08.509-.228.723-.15.213-.361.38-.61.479a1.412 1.412 0 01-.784.074 1.377 1.377 0 01-.695-.356 1.285 1.285 0 01-.371-.667 1.25 1.25 0 01.077-.751c.103-.238.277-.441.5-.584a1.4 1.4 0 011.713.163c.254.244.397.574.398.919z","fill":"#525F7F"}}),_c('path',{attrs:{"d":"M24.663 27.202a.776.776 0 01-.578.259H7.915a.777.777 0 01-.584-.254.709.709 0 01-.166-.594l1.481-7.806a.714.714 0 01.263-.426.77.77 0 01.487-.163h1.317c1.5 3.36 3.303 6.562 3.633 7.14.163.285.402.522.693.686.291.165.623.25.961.249.334 0 .663-.086.95-.248.289-.162.526-.396.689-.676.334-.578 2.175-3.784 3.675-7.151H22.6a.77.77 0 01.488.163c.137.108.23.259.262.426l1.5 7.806a.69.69 0 01-.187.59z","fill":"#B4BCCF"}})])
          )
        }
      }
    